
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/external-experts/cursor",
      function () {
        return require("private-next-pages/docs/external-experts/cursor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/external-experts/cursor"])
      });
    }
  